import { render, staticRenderFns } from "./bundle-add-edit-component.vue?vue&type=template&id=6a892971&scoped=true&lang=pug"
import script from "./bundle-add-edit-component.js?vue&type=script&lang=js&external"
export * from "./bundle-add-edit-component.js?vue&type=script&lang=js&external"
import style0 from "./bundle-add-edit-component.vue?vue&type=style&index=0&id=6a892971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a892971",
  null
  
)

export default component.exports